/* Foucault · La medida en la muñeca (v6.1). Nativo, sin librerías. Estilos en foucault-v6.css.
   Dos piezas con la misma regla:
   - [data-fc-mu]    "En tu muñeca" de la ficha (snippets/fc-en-tu-muneca.liquid): una barra para la muñeca.
   - [data-fc-talla] "¿Cómo te queda?" de la portada (sections/fc-muneca.liquid): muñeca y caja, con relojes reales.
   Ancho de la muñeca vista desde arriba = contorno / π. Proporción caja / ancho:
   bajo 0,75 discreto · hasta 0,90 justo · sobre eso, con presencia.
   Solo se anima transform (scaleX de la muñeca, scale de la caja, translateX del medidor).
   La muñeca elegida se guarda en este navegador (fcMunecaCm) y la usan ambas piezas. */
(function () {
  if (window.fcMuneca) return;
  window.fcMuneca = true;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var curva = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var CLAVE = 'fcMunecaCm';
  var ETIQ = { discreto: 'Discreto', justo: 'Justo', presencia: 'Con presencia' };
  function coma(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }
  function leer() { try { var v = Number(localStorage.getItem(CLAVE)); return v >= 14 && v <= 21 ? v : 0; } catch (e) { return 0; } }
  function guardar(v) { try { localStorage.setItem(CLAVE, String(v)); } catch (e) {} }
  function ancho(cm) { return (cm * 10) / Math.PI; }
  function encaje(p, d) { return p < d.cd ? 'discreto' : p <= d.cp ? 'justo' : 'presencia'; }
  function lleno(r) {
    var pct = ((Number(r.value) - Number(r.min)) / (Number(r.max) - Number(r.min))) * 100;
    r.style.setProperty('--lleno', pct.toFixed(1) + '%');
  }
  function latido(el) {
    if (quieto || !el || !el.animate) return;
    el.animate([{ opacity: 0.2, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 220, easing: curva });
  }
  /* Mientras el dedo arrastra una barra, el dibujo sigue al dedo sin transición (respuesta directa);
     con teclado o al soltar, se asienta con una transición corta. */
  function directo(raiz, rango) {
    var on = function () { raiz.setAttribute('data-directo', ''); };
    var off = function () { raiz.removeAttribute('data-directo'); };
    rango.addEventListener('pointerdown', on);
    rango.addEventListener('pointerup', off);
    rango.addEventListener('pointercancel', off);
    rango.addEventListener('change', off);
    rango.addEventListener('blur', off);
  }
  function dibujar(q, a, p) {
    var k = 'scaleX(' + (a / 54).toFixed(3) + ')';
    var brazo = q('[data-mu-brazo],[data-brazo]'), cota = q('[data-mu-cota],[data-cota]'), correa = q('[data-mu-correa],[data-correa]'), carril = q('[data-mu-carril],[data-carril]');
    if (brazo) brazo.style.transform = k;
    if (cota) cota.style.transform = k;
    if (correa) correa.style.transform = 'scaleX(' + ((a + 2) / 56).toFixed(3) + ')';
    if (carril) carril.style.transform = 'translateX(' + (Math.min(1, Math.max(0, (p - 0.5) / 0.6)) * 100).toFixed(1) + '%)';
  }

  /* ---------- Ficha ---------- */
  function ficha(raiz) {
    var d = raiz.dataset;
    var q = function (s) { return raiz.querySelector(s); };
    var rango = q('[data-mu-rango]'), control = q('[data-mu-control]');
    if (!rango || !control) return;
    var cfg = { cd: Number(d.corteDiscreto) || 0.75, cp: Number(d.cortePresencia) || 0.9 };
    var textos = { discreto: d.eDiscreto, justo: d.eJusto, presencia: d.ePresencia };
    var diam = Number(d.diametro);
    var cm = leer() || 17;
    var primera = true;

    function pintar() {
      var a = ancho(cm), p = diam / a, fit = encaje(p, cfg);
      dibujar(q, a, p);
      var cmT = coma(cm), mmT = coma(diam);
      rango.value = String(cm);
      lleno(rango);
      rango.setAttribute('aria-valuetext', cmT + ' cm');
      var sal = q('[data-mu-salida]'); if (sal) sal.textContent = cmT + ' cm';
      var tu = q('[data-mu-tu]'); if (tu) tu.textContent = (d.lTu || '').replace('__cm__', cmT);
      var fr = q('[data-mu-frase]'); if (fr) fr.textContent = (d.lFrase || '').replace('__mm__', mmT).replace('__pct__', Math.round(p * 100));
      var fig = q('[data-mu-figura]'); if (fig) fig.setAttribute('aria-label', (d.lFigura || '').replace('__mm__', mmT).replace('__cm__', cmT));
      if (raiz.dataset.fit !== fit || primera) {
        raiz.dataset.fit = fit;
        var pal = q('[data-mu-palabra]');
        if (pal) pal.textContent = ETIQ[fit];
        var ex = q('[data-mu-explica]'); if (ex) ex.textContent = textos[fit] || '';
        if (!primera) latido(pal);
      }
      primera = false;
    }
    rango.addEventListener('input', function () { cm = Number(rango.value); pintar(); });
    rango.addEventListener('change', function () { guardar(cm); });
    directo(raiz, rango);
    control.hidden = false;
    pintar();
  }

  /* ---------- Portada ---------- */
  function portada(raiz) {
    var d = raiz.dataset;
    var q = function (s) { return raiz.querySelector(s); };
    var rCm = q('[data-cm-rango]'), rCaja = q('[data-caja-rango]'), reloj = q('[data-reloj]');
    if (!rCm || !rCaja || !reloj) return;
    var cfg = { cd: Number(d.corteDiscreto) || 0.75, cp: Number(d.cortePresencia) || 0.9 };
    var lectura = q('[data-lectura]'), ocupa = q('[data-ocupa]'), sugTitulo = q('[data-sug-titulo]'), sugRango = q('[data-sug-rango]'), lista = q('[data-sug-lista]'), figura = q('[data-figura]');
    var relojes = [];
    try { relojes = JSON.parse(q('[data-relojes]').textContent) || []; } catch (e) { relojes = []; }
    var cMin = Number(rCaja.min), cMax = Number(rCaja.max);

    var guardado = leer();
    var cm = guardado || Number(rCm.value) || 17;
    var caja = Number(rCaja.value) || 44;
    var primera = true, firma = '', tocado = false, demo = 0, espera = 0;

    function ideal() { return Math.min(cMax, Math.max(cMin, Math.round(((cfg.cd + cfg.cp) / 2) * ancho(cm)))); }
    if (guardado) { caja = ideal(); rCm.value = String(cm); rCaja.value = String(caja); }

    function pintar() {
      var a = ancho(cm), p = caja / a, fit = encaje(p, cfg);
      dibujar(q, a, p);
      reloj.style.transform = 'scale(' + (caja / 44).toFixed(3) + ')';
      lleno(rCm); lleno(rCaja);
      var cmT = coma(cm) + ' cm', mmT = caja + ' mm';
      var s1 = q('[data-cm-salida]'), s2 = q('[data-caja-salida]');
      if (s1) s1.textContent = cmT;
      if (s2) s2.textContent = mmT;
      rCm.setAttribute('aria-valuetext', cmT);
      rCaja.setAttribute('aria-valuetext', mmT);
      raiz.dataset.fit = fit;
      if (lectura && lectura.textContent.trim() !== ETIQ[fit]) {
        lectura.textContent = ETIQ[fit];
        if (!primera) latido(lectura);
      }
      if (ocupa) ocupa.textContent = 'La caja cubre el ' + Math.round(p * 100) + ' % de tu muñeca.';
      if (sugRango) sugRango.textContent = (d.lRango || '').replace('__min__', Math.ceil(cfg.cd * a)).replace('__max__', Math.floor(cfg.cp * a));
      if (figura) figura.setAttribute('aria-label', (d.lFigura || '').replace('__mm__', caja).replace('__cm__', coma(cm)));
    }

    function sugerir() {
      if (!lista || !relojes.length) { if (lista) lista.closest('.fc-talla__sug').hidden = true; return; }
      var a = ancho(cm);
      if (sugTitulo) sugTitulo.textContent = (d.lSug || '').replace('__mm__', caja);
      var orden = relojes.slice().sort(function (x, y) { return Math.abs(x.d - caja) - Math.abs(y.d - caja) || x.d - y.d; });
      var elegidos = [], marcas = [];
      orden.forEach(function (r) { if (marcas.indexOf(r.m) < 0) marcas.push(r.m); });
      marcas.forEach(function (m) {
        if (elegidos.length >= 3) return;
        for (var i = 0; i < orden.length; i++) { if (orden[i].m === m && Math.abs(orden[i].d - caja) <= 3) { elegidos.push(orden[i]); break; } }
      });
      orden.forEach(function (r) { if (elegidos.length < 3 && elegidos.indexOf(r) < 0) elegidos.push(r); });
      elegidos.sort(function (x, y) { return x.d - y.d; });

      var urls = elegidos.map(function (r) { return r.u; }).join('|');
      var fits = elegidos.map(function (r) { return encaje(r.d / a, cfg); });
      var clave = urls + '#' + fits.join('|');
      if (clave === firma) return;
      var mismos = firma.split('#')[0] === urls;
      firma = clave;

      if (mismos && lista.children.length) {
        [].forEach.call(lista.querySelectorAll('[data-sug-fit]'), function (el, i) { el.dataset.fit = fits[i]; el.textContent = ETIQ[fits[i]]; });
        return;
      }
      var nuevos = elegidos.map(function (r, i) {
        var li = document.createElement('li');
        var aEl = document.createElement('a'); aEl.className = 'fc-talla__reloj-sug'; aEl.href = r.u;
        var foto = document.createElement('span'); foto.className = 'fc-talla__sug-foto';
        var img = document.createElement('img'); img.src = r.i; img.alt = ''; img.width = 360; img.height = 360; img.decoding = 'async'; img.loading = 'lazy';
        foto.appendChild(img);
        var nom = document.createElement('span'); nom.className = 'fc-talla__sug-nombre'; nom.textContent = r.n;
        var dat = document.createElement('span'); dat.className = 'fc-talla__sug-datos'; dat.textContent = coma(r.d) + ' mm · ' + r.p;
        var tag = document.createElement('span'); tag.className = 'fc-talla__sug-fit'; tag.setAttribute('data-sug-fit', ''); tag.dataset.fit = fits[i]; tag.textContent = ETIQ[fits[i]];
        aEl.appendChild(foto); aEl.appendChild(tag); aEl.appendChild(nom); aEl.appendChild(dat);
        li.appendChild(aEl);
        return li;
      });
      lista.innerHTML = '';
      nuevos.forEach(function (li) { lista.appendChild(li); });
      if (!primera && !quieto) {
        nuevos.forEach(function (li, i) {
          if (li.animate) li.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 260, delay: i * 60, easing: curva, fill: 'backwards' });
        });
      }
    }
    function luego() { clearTimeout(espera); espera = setTimeout(sugerir, 140); }
    function cancelar(e) {
      tocado = true;
      if (!demo) return;
      cancelAnimationFrame(demo);
      demo = 0;
      if (!(e && e.target && e.target.matches && e.target.matches('.fc-rango'))) raiz.removeAttribute('data-directo');
    }

    rCm.addEventListener('input', function () { cancelar(null); cm = Number(rCm.value); caja = ideal(); rCaja.value = String(caja); pintar(); luego(); });
    rCm.addEventListener('change', function () { guardar(cm); });
    rCaja.addEventListener('input', function () { cancelar(null); caja = Number(rCaja.value); pintar(); luego(); });
    raiz.addEventListener('pointerdown', cancelar, { passive: true });
    directo(raiz, rCm);
    directo(raiz, rCaja);

    [].forEach.call(raiz.querySelectorAll('[data-control]'), function (el) { el.hidden = false; });
    pintar();
    sugerir();
    primera = false;

    /* Demostración una sola vez: la caja recorre 36 y 52 mm y vuelve */
    if (!quieto && 'IntersectionObserver' in window) {
      var original = caja, paradas = [original, 36, 52, original], tramo = 650;
      var suave = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        if (tocado) return;
        var inicio = null;
        var paso = function (t) {
          if (tocado) { raiz.removeAttribute('data-directo'); return; }
          raiz.setAttribute('data-directo', '');
          if (inicio === null) inicio = t;
          var total = (t - inicio) / tramo;
          var i = Math.min(paradas.length - 2, Math.floor(total));
          var local = Math.min(1, total - i);
          var v = Math.round(paradas[i] + (paradas[i + 1] - paradas[i]) * suave(local));
          if (v !== caja) { caja = v; rCaja.value = String(v); pintar(); }
          if (total < paradas.length - 1) demo = requestAnimationFrame(paso); else { demo = 0; raiz.removeAttribute('data-directo'); }
        };
        setTimeout(function () { if (!tocado) demo = requestAnimationFrame(paso); }, 500);
      }, { threshold: 0.5 });
      io.observe(raiz);
    }
  }

  function iniciar() {
    [].forEach.call(document.querySelectorAll('[data-fc-mu]'), ficha);
    [].forEach.call(document.querySelectorAll('[data-fc-talla]'), portada);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
